import { Flex } from "@chakra-ui/react";
import { Activities } from "src/modules/activity-log/activity";
import RoundButton from "../RoundButton";
import ButtonsGroup from "../../ControlButtons/ButtonsGroup";
import SeeMeButton from "./SeeMeButton";
import FreemiumVideoButton from "./FreemiumVideoButton";
import PttButton from "../PttButton";
import environment, { BarkioOnly } from "src/utils/environment";
import { ReactComponent as StartVideoIcon } from "./video.svg";
import { ReactComponent as StopVideoIcon } from "./video-off.svg";
import { ReactComponent as OpenCommandsIcon } from "./command.svg";
import { ReactComponent as FlashlightIcon } from "./flashlight.svg";

export default function DefaultGroup({
  in: inProp,
  isDarkMode,
  parentStation,
  openCommandsGroup,
  isFreeVersion,
  closeCameraList
}) {
  const {
    toggleMonitoringMode,
    toggleSeeMe,
    togglePushToTalk,
    togglePurchaseFlow,
    primaryStation,
    toggleSeeMeButton,
    renderSeeMeButton
  } = parentStation;

  const {
    mode,
    activity,
    senderStationConfiguration,
    cameraAndFlashlightState,
    flashlightManager,
    seeMeState,
    pushToTalkState,
    opusRecorder,
    jid
  } = primaryStation;
  const hasBabyCamera = senderStationConfiguration.numberOfCameras > 0;
  const background =
    activity === Activities.AWAKE || (activity === Activities.MOTION && environment.isBibino) || mode === "video"
      ? "black20"
      : "primary";

  const renderFlashlightButton = mode === "video" && cameraAndFlashlightState.flashlightAvailable;

  return (
    <>
      <ButtonsGroup in={inProp} appear={false}>
        <Flex
          alignItems={environment.isBibino ? "flex-end" : "center"}
          flexDirection="column"
          width={environment.isBibino ? "200px" : null}
        >
          {hasBabyCamera &&
            (isFreeVersion ? (
              <FreemiumVideoButton
                toggleMonitoringMode={() => toggleMonitoringMode(jid)}
                togglePurchaseFlow={togglePurchaseFlow}
                background={background}
                mode={mode}
                StartVideoIcon={StartVideoIcon}
                StopVideoIcon={StopVideoIcon}
                closeCameraList={closeCameraList}
              />
            ) : (
              <RoundButton
                // mb={["16px", "24px"]}
                mb="3.0534vmin"
                bg={background}
                // size={["56px", "72px", "80px"]}
                size="10.69vmin"
                icon={mode === "audio" ? StartVideoIcon : StopVideoIcon}
                iconFill="white"
                iconSize="50%"
                onClick={() => toggleMonitoringMode(jid)}
              />
            ))}

          {renderFlashlightButton && (
            <RoundButton
              // mb={["16px", "24px"]}
              mb="3.0534vmin"
              bg={cameraAndFlashlightState.flashlightEnabled ? "white" : "black20"}
              // size={["56px", "72px", "80px"]}
              size="10.69vmin"
              icon={FlashlightIcon}
              iconFill={cameraAndFlashlightState.flashlightEnabled ? "black54" : "white"}
              iconSize="50%"
              onClick={
                cameraAndFlashlightState.flashlightEnabled ? flashlightManager?.turnOff : flashlightManager?.turnOn
              }
            />
          )}
          <BarkioOnly
            bg={background}
            // size={["56px", "72px", "80px"]}
            size="10.69vmin"
            icon={OpenCommandsIcon}
            iconFill="white"
            iconSize="50%"
            onClick={openCommandsGroup}
          >
            {RoundButton}
          </BarkioOnly>
          {environment.isBibino ? (
            <Flex alignItems="center" pb="12px">
              <SeeMeButton
                transition="all 700ms ease"
                zIndex={-1}
                opacity={0}
                transform="translate(80px, 0px)"
                {...(renderSeeMeButton &&
                  mode === "video" && {
                    zIndex: 1,
                    opacity: 1,
                    transform: "translate(0px,0px)"
                  })}
                mr="16px"
                toggleSeeMe={toggleSeeMe}
                state={seeMeState}
              />

              <PttButton
                bg={background}
                // size={["56px", "72px", "80px"]}
                isDarkMode={isDarkMode}
                mode={mode}
                activity={activity}
                togglePushToTalk={() => togglePushToTalk() && toggleSeeMeButton()}
                state={pushToTalkState}
                noiseMeter={opusRecorder && opusRecorder.noiseMeter}
              />
            </Flex>
          ) : null}
        </Flex>
      </ButtonsGroup>
    </>
  );
}
